import { createSvgIcon } from "@mui/material";

export const AlignLeftIcon = createSvgIcon(
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 2.5V17.5M18 10H6.33333M6.33333 10L12.1667 15.8333M6.33333 10L12.1667 4.16667"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  "AlignLeftIcon",
);
